<section *ngIf="!hide" class="z-[100] h-screen w-screen fixed top-0 left-0 flex justify-center items-center bg-primary-1-900/60">
  <div class="rounded-[1.25rem] bg-white">
    <ng-content></ng-content>
  </div>
</section>
